// import React from 'react';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import axios from "./axios";
import './App.css';
// import EventView from '../src/img/web_image.png';
import seriti_loader1 from './Images/logo/Seriti Loader.gif';
import seriti_loader from './Images/logo/Seriti BW - system logo.png';

const MaintenanceMode = () => {
  // console.log("rjfjdk");
  const navigate = useNavigate();
  const [Email, setEmail] = useState("");
  const [Subject, setSubject] = useState("");
  const [Message, setMessage] = useState("");
 
  const handleValidation = () => {
    var flag = true;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  
    if (Email === "") {
      alert("Please Enter Email");
      flag = false;

    }else if (!emailRegex.test(Email)) {
      alert("Please Enter a Valid Email Address");
      flag = false;

    }else if (Subject === "") {
      alert("Please Enter Subject");
      flag = false;

    }else if (Message === "") {
      alert("Please Enter Message");
      flag = false;
    }
    return flag;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const flag = handleValidation();
    if (flag) {
        const payload = {
            email : Email,
            subject: Subject,
            message: Message,
        };
        // console.log(payload);
          axios.post("send_test_email", payload)
            .then((response) => {
                // console.log(response)
               alert('Email Send Successfully');
            })
            .catch(() => {
                //setLoginLoader(false);
            });
    }
};
  
  return (

    <div style={{ background: 'linear-gradient(145deg, rgb(251 208 201 / 20%) 0%, rgb(255 209 253 / 20%) 100%)' }}>
      <div className="row w-100 px-4" >

        <h1 className="maintenance-title text-center">Test Send Email</h1>
        <form name="loginform" id="loginform" method="post" onSubmit={handleSubmit} >
          <table width="30%" border="1" align="center" cellPadding={5} cellSpacing={5}>
            <tbody>

              <tr>
                <td>Email</td>
                <td><input type="text" className="login-input" name="email" value={Email} tabIndex={10} onChange={(e) => { setEmail(e.target.value) }} /></td>
              </tr>

              <tr>
                <td>Subject</td>
                <td><input type="text" className="login-input" name="subject" value={Subject} tabIndex={10} onChange={(e) => { setSubject(e.target.value) }} /></td>
              </tr>

              <tr>
                <td>Message</td>
                <td><input type="text" className="login-input" name="message" value={Message} tabIndex={10} onChange={(e) => { setMessage(e.target.value) }} /></td>
              </tr>

              <tr>
                <td colSpan={2} align='center'><input type="submit" id="submit" value="Send" tabIndex={100} /></td>
              </tr>

            </tbody>
          </table>
        </form>

      </div>
    </div>
  );
};

export default MaintenanceMode;